import { render, staticRenderFns } from "./ImportModal.vue?vue&type=template&id=38adcb83&scoped=true"
import script from "./ImportModal.vue?vue&type=script&lang=ts"
export * from "./ImportModal.vue?vue&type=script&lang=ts"
import style1 from "./ImportModal.vue?vue&type=style&index=1&id=38adcb83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38adcb83",
  null
  
)

export default component.exports